/* For Info compliance type*/
const cookieEU_EN_v1 = {
    message:
        'This website uses essential which are necessary to perform all of its features. This data may be processed by our IT service providers (such as Salesforce, Securiti AI, etc.). Data protection is a priority, and we use, thanks to our service provider Piwik Pro, an IP address anonymization technology for the cookies used for the purpose of audience measurement and statistics on the legal basis of our legitimate interest. You can configure your browser to refuse essential cookies, but in this case the site may not work correctly. You also have the option to reject anonymized analytical cookies or performance cookies by going to the "cookies settings" section.',
    accept: "OK",
    know_more:
        "Know more [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/en/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Privacy Policy</a>]",
    mesg_2nd:
        "<span>This website uses only essential cookies. Click here to see our <a href='https://vinfastauto.eu/en/privacy-policy' target='_blank' class='cc-link' id='showPrefCent'>privacy policy</a></span>",
    btn_2nd: "OK",
};
const cookieEU_FR_v1 = {
    message:
        "Ce site web utilise des cookies essentiels qui sont nécessaires à la mise en œuvre et au bon fonctionnement de l'ensemble de ses fonctionnalités. Ces données sont susceptibles d'être traitées par nos prestataires informatiques (comme Salesforce, Securiti AI...). La protection de vos données personnelles étant une priorité, nous avons recourt, grâce à notre prestataire Piwik Pro, à une technologie d'anonymisation des adresses IP pour les cookies destinés aux mesures d'audience et de statistiques sur la base de notre intérêt légitime. Vous pouvez configurer votre navigateur pour refuser les cookies essentiels mais dans ce cas le site risque de ne pas fonctionner correctement. Vous avez également la possibilité de vous opposer aux cookies analytics anonymisés ou aux cookies de performance en vous rendant dans la section \"Paramétrages des cookies et gestion du consentement\".",
    accept: "OK",
    know_more:
        "En savoir plus [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/fr/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Politique de confidentialité</a>]",
    mesg_2nd:
        "<span>Ce site n'utilise que des cookies qui sont nécessaires à la mise en œuvre de ses fonctionnalités. Cliquez ici pour prendre connaissance de notre <a href='https://vinfastauto.eu/fr/privacy-policy' class='cc-link' target='_blank' id='showPrefCent'>politique de confidentialité</a>.</span>",
    btn_2nd: "OK",
};
const cookieEU_DE_v1 = {
    message:
        'Diese Website verwendet essentielle  Cookies, die für die Ausführung aller ihrer Funktionen erforderlich sind. Diese Daten können von unseren IT-Dienstleistern (wie Salesforce, Securiti AI, etc.) verarbeitet werden. Der Datenschutz hat Priorität, und wir verwenden dank unseres Dienstleisters Piwik Pro eine Technologie zur Anonymisierung von IP-Adressen für die Cookies zum Zwecke der Zielgruppenmessung und der Erstellung von Statistiken auf der Rechtsgrundlage unseres berechtigten Interesses. Sie können Ihren Browser so konfigurieren, dass er wesentliche Cookies ablehnt, aber in diesem Fall funktioniert die Website möglicherweise nicht richtig. Sie haben auch die Möglichkeit, anonymisierte analytische Cookies oder Leistungs-Cookies abzulehnen, indem Sie den Abschnitt "Cookie-Einstellungen" aufrufen.',
    accept: "OK",
    know_more:
        "Erfahren Sie mehr [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/de/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Datenschutz- und Cookie-Richtlinie</a>]",
    mesg_2nd:
        "<span>Unsere Website setzt nur notwendige Cookies ein. Klicken Sie hier, um die <a href='https://vinfastauto.eu/de/privacy-policy' class='cc-link' target='_blank' id='showPrefCent'>Datenschutz- und Cookie-Richtlinie einzusehen</a>.</span>",
    btn_2nd: "OK",
};
const cookieEU_NL_v1 = {
    message:
        'Deze site maakt gebruik van essentiële cookies die nodig zijn voor de implementatie en goede werking van alle functies. Deze gegevens kunnen worden verwerkt door onze IT-serviceproviders (zoals Salesforce, Securiti AI, enz.). Omdat de bescherming van uw persoonlijke gegevens een prioriteit is, gebruiken we, dankzij onze serviceprovider Piwik Pro, een technologie voor het anonimiseren van IP-adressen voor cookies voor doeleinden van publieksmeting en statistieken op basis van ons legitieme belang. U kunt uw browser zo configureren dat essentiële cookies worden geweigerd, maar in dit geval werkt de site mogelijk niet correct. U heeft ook de mogelijkheid om u te verzetten tegen geanonimiseerde analytische cookies of prestatiecookies door naar het gedeelte "cookies instellingen" te gaan.',
    accept: "OK",
    know_more:
        "Meer weten [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/nl/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>privacy wetgeving</a>]",
    mesg_2nd:
        "<span>TOnze website gebruikt alleen noodzakelijke cookies. Klik hier om ons <a href='https://vinfastauto.eu/nl/privacy-policy' class='cc-link' id='showPrefCent' target='_blank'>privacybeleid</a> te zien</span>",
    btn_2nd: "OK",
};

/* For Opt-in compliance type */
const cookieEU_EN_v2 = {
    message:
        "Our website uses essential cookies that are necessary for the implementation and proper functioning of all its features. We also use cookies to measure the audience and the performance of our website and to monitor advertising results. This data may be processed by our service providers and digital solutions suppliers. You can accept or decline cookies based on consent. <br />You can also set your browser to refuse essential cookies but if you do so the site may not function properly. You also have the possibility of opting out of Analytics cookies based on IP address anonymization technology by going to the \"Cookie settings and consent management\" section.",
    accept: "ACCEPT",
    dismiss: "REJECT",
    pref_link: "Cookie management by purposes & recipients of personal data",
    know_more:
        "Know more [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/en/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Privacy Policy</a>]",
    mesg_2nd:
        "<span>This website uses cookies. To return to your preferences, click on: <a href='#' id='showPrefCent' class='cc-link' onclick='changeLayoutAfter1stVisit()'>cookies settings</a>. To know more click on our <a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/en/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Privacy Policy</a></span>",
    btn_2nd: "OK",
    btn_save: "SAVE SETTINGS",

    pref_header: "Allow the use of cookies from VinFast on this browser?",
    pref_essential: "Essential",
    pref_essential_desc:
        "These cookies are essential to support core site functionality such as providing secure log-in.",

    pref_analytics: "Analytics and audience metrics",
    pref_analytics_desc:
        "The analytical cookies that we use on our website allow us to count the number of visitors to our site, in particular to establish statistics and volumes of traffic and use. These cookies may be deposited by Vinfast or our service providers. These cookies use IP address anonymisation technology.",
    pref_analytics_optout:
        "We will not be able to analyze your site usage to provide custom content.",

    pref_advert: "Advertising",
    pref_advert_desc:
        "These cookies helps serve advertising content that is relevant to you.",
    pref_advert_optout:
        "We will not be able to provide you with interest-based offers or ads.",

    pref_performance: "Performances & Functionalities",
    pref_performance_desc:
        "These cookies facilitate measurement and analytics for improved browsing experience.",
    pref_performance_optout:
        "We will not be able to conduct analytics to optimize site functionality and performance, or remember what is in your shopping cart.",

    pref_social: "Social Networking",
    pref_social_desc:
        "These cookies allow social interactions such as posting comments on our site.",
    pref_social_optout:
        "We will not be able to let you share pages with social networks.",
    first_party: "First Party Cookie Providers",
    third_party: "Third Party Cookie Providers",
};
const cookieEU_FR_v2 = {
    message:
        "Notre site web utilise des cookies essentiels qui sont nécessaires à la mise en œuvre et au bon fonctionnement de l'ensemble de ses fonctionnalités. Nous utilisons également des cookies pour mesurer l'audience et la performance de notre site ainsi que pour contrôler les résultats publicitaires. Ces données sont susceptibles d'être traitées par nos prestataires & fournisseurs de solutions digitales. <br />Vous pouvez accepter ou refuser les cookies reposant sur le consentement. Vous pouvez également configurer votre navigateur pour refuser les cookies essentiels mais dans ce cas le site risque de ne pas fonctionner correctement. Vous avez également la possibilité de vous opposer aux Cookies Analytics reposant sur une technologie d’anonymisation de l’adresse IP en vous rendant dans la section \"Paramétrages des cookies et gestion du consentement\".",
    accept: "ACCEPTER",
    dismiss: "REFUSER",
    pref_link:
        "Paramétrage des cookies et gestion du consentement par finalités ",
    know_more:
        "En savoir plus [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/fr/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Politique de confidentialité</a>]",
    pref_header:
        "Autoriser l'utilisation des cookies de VinFast sur ce navigateur ?",

    mesg_2nd:
        "<span>Ce site utilise des cookies. Pour revenir sur vos choix, cliquez sur: \"<a href='#' id='showPrefCent' class='cc-link' onclick='changeLayoutAfter1stVisit()'>paramétrage des cookies et gestion du consentement</a>\".",
    btn_2nd: "OK",
    btn_save: "SAUVEGARDER LES PARAMÈTRES DE COOKIES",

    pref_essential: "Essentiel",
    pref_essential_desc:
        "Ces cookies sont essentiels pour prendre en charge les fonctionnalités principales du site, telles que la fourniture d'une connexion sécurisée.",

    pref_analytics: "Analytics et mesures d'audience",
    pref_analytics_desc:
        "Les Cookies analytiques que nous utilisons sur notre site nous permettent de comptabiliser le nombre de visiteurs sur notre site notamment pour établir des statistiques et des volumes de fréquentation et d'utilisation. Ces cookies peuvent être déposés par Vinfast ou nos prestataires de services. Ces cookies utilisent une technologie d'anonymisation de l'adresse IP.",
    pref_analytics_optout:
        "Nous ne serons pas en mesure d'analyser l'utilisation de votre site pour fournir un contenu personnalisé.",

    pref_advert: "Publicité",
    pref_advert_desc:
        "Ces cookies permettent de diffuser du contenu publicitaire personnalisé.",
    pref_advert_optout:
        "Nous ne serons pas en mesure de vous proposer des offres ou des publicités personnalisées basées sur vos centres d'intérêt.",

    pref_performance: "Performances & Fonctionalités",
    pref_performance_desc:
        "Ces cookies facilitent la mesure et l'analyse pour une meilleure expérience de navigation.",
    pref_performance_optout:
        "Nous ne serons pas en mesure d'effectuer des analyses pour optimiser les fonctionnalités et les performances du site, ou de mémoriser ce qui se trouve dans votre panier.",

    pref_social: "Réseaux sociaux",
    pref_social_desc:
        "Ces cookies permettent des interactions avec les réseaux sociaux telles que la publication de commentaires sur notre site",
    pref_social_optout:
        " Nous ne pourrons pas vous permettre de partager des pages avec les réseaux sociaux.",
    first_party: "Fournisseurs de cookies propriétaires",
    third_party: "Fournisseurs de cookies tiers",
};
const cookieEU_DE_v2 = {
    message:
        "Unsere Website verwendet wichtige Cookies die für die Umsetzung und das ordnungsgemäße Funktionieren aller Funktionen erforderlich sind. Wir verwenden Cookies auch um die Besucherzahl und die Leistung unserer Website zu messen und die Werbeergebnisse zu überwachen. Diese Daten können von unseren Dienstleistern und Anbietern digitaler Lösungen verarbeitet werden. <br />Sie können Cookies mit Ihrer Zustimmung akzeptieren oder ablehnen. Sie können Ihren Browser auch so einstellen, dass wichtige Cookies abgelehnt werden, aber in diesem Fall funktioniert die Website möglicherweise nicht richtig. Sie haben auch die Möglichkeit Analytics-Cookies, die auf der Technologie zur Anonymisierung von IP-Adressen basieren, abzulehnen indem Sie den Abschnitt \"Cookie-Einstellungen und Zustimmungsmanagement\" aufrufen.",
    accept: "Akzeptieren",
    dismiss: "Ablehnen",
    pref_link:
        "Cookie Management nach Verwendungen und Empfängern von<br /> personenbezogenen Daten",
    know_more:
        "Erfahren Sie mehr [<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/de/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Datenschutz- und Cookie-Richtlinie</a>]",
    pref_header:
        "Zustimmung zum Einsatz von Cookies von VinFast auf diesem Browser",

    mesg_2nd:
        "<span>Diese Website setzt Cookies ein. Bitte klicken Sie auf <a href='#' id='showPrefCent' class='cc-link' onclick='changeLayoutAfter1stVisit()'>cookie-Einstellungen</a>, um Ihre Einstellungen aufzurufen. Um mehr zu erfahren, klicken Sie auf unsere <a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/de/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Datenschutz- Richtlinie</a>.</span>",
    btn_2nd: "OK",
    btn_save: "EINSTELLUNGEN SPEICHERN",

    pref_essential: "Notwendig",
    pref_essential_desc:
        "Diese Cookies sind erforderlich, um wesentliche Funktionen der Website zu ermöglichen, z.B. einen sicheren Log-In.",

    pref_performance: "Performances und Funktionalität",
    pref_performance_desc:
        "Diese Cookies ermöglichen Messungen und Analysenum das Erlebnis der Website zu verbessern",
    pref_performance_optout:
        "Eine Analyse mit dem Zweck der Optimierung der Funktionalität und Leistungsfähigkeit wird nicht möglich sein. Außerdem ist die Möglichkeit der Speicherung des Inhalts Ihres Einkaufskorbs eingeschränkt.",

    pref_analytics: "Analytics und Publikumsmessung",
    pref_analytics_desc:
        "Die analytischen Cookies, die wir auf unserer Website verwenden, ermöglichen es uns, die Anzahl der Besucher auf unserer Website zu erfassen, insbesondere um Statistiken und Volumen der Besucherzahlen und der Nutzung zu erstellen. Diese Cookies können von Vinfast oder unseren Dienstleistern abgelegt werden. Diese Cookies verwenden eine Technologie zur Anonymisierung der IP-Adresse.",
    pref_analytics_optout:
        "Wir werden nicht in der Lage sein, die Nutzung unserer Website zu analysieren und ihren Inhalt zu verbessern.",

    pref_advert: "Werbung",
    pref_advert_desc:
        "Diese Cookies unterstützen uns dabei, für Sie relevante Werbeinhalte bereitzustellen.",
    pref_advert_optout:
        "Wir werden Ihnen keine interessensbasierten Angebote oder Werbeinhalte bereitstellen können.",

    pref_social: "Soziale Netzwerke",
    pref_social_desc:
        "Diese Cookies erlauben es uns, mit sozialen Netzwerken zu interagieren und z.B. Posts auf unserer Seite darzustellen",
    pref_social_optout:
        "Wir werden es nicht ermöglichen können, dass Sie Seiten mit sozialen Netzwerken teilen.",
    first_party: "Anbieter von Erstanbieter-Cookies",
    third_party: "Drittanbieter von Cookies",
};
const cookieEU_NL_v2 = {
    message:
        "Onze website maakt gebruik van essentiële cookies die noodzakelijk zijn voor de implementatie en goede werking van al zijn functies. Wij gebruiken ook cookies om het publiek en de prestaties van onze website te meten en om advertentieresultaten te monitoren. Deze gegevens kunnen worden verwerkt door onze dienstverleners en providers van digitale oplossingen. <br />U kunt naar eigen goeddunken cookies accepteren of weigeren. U kunt uw browser ook zo instellen dat essentiële cookies worden geweigerd, maar als u dat doet, werkt de site mogelijk niet naar behoren. U hebt ook de mogelijkheid om Analytics-cookies op basis van IP-adres anonimiseringstechnologie te selecteren door naar \"Cookie-instellingen en machtigingenbeheer\" te gaan.",
    accept: "ACCEPTEREN",
    dismiss: "WEIGEREN",
    pref_link: "Cookie management per doel en ontvanger van persoons gegevens",
    know_more:
        "Meer weten (<a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='https://vinfastauto.eu/nl/privacy-policy' rel='noopener noreferrer nofollow' target='_blank'>privacy wetgeving</a>)",
    pref_header: "VinFast cookies toestaan op deze browser?",

    mesg_2nd:
        "<span>Deze website cookies: Om terug te keren naar je voorkeuren, klik op: <a href='#' id='showPrefCent' class='cc-link' onclick='changeLayoutAfter1stVisit()'>Cookies instellingen</a>. Klik voor meer informatie op ons <a aria-label='learn more about cookies' role='button' tabindex='0' class='cc-link' href='/nlprivacy-policy' rel='noopener noreferrer nofollow' target='_blank'>Privacybeleid</a></span>",
    btn_2nd: "OK",
    btn_save: "INSTELLINGEN OPSLAAN",

    pref_essential: "Essentieel",
    pref_essential_desc:
        "Deze cookies zijn essentieel om de website te laten functioneren, zoals beveiligde log-in.",

    pref_performance: "Prestaties en functionaliteit",
    pref_performance_desc:
        "Deze cookies faciliteren meetingen en analyses voor een verbeterde website ervaring",
    pref_performance_optout:
        "We zullen niet in staat zijn om analyses uit te voeren om de website optimaal te laten functioneren en presteren. Ook kunnen we niet onthouden wat in uw winkelmandje zit.",

    pref_analytics: "Analytics en publieksmeting",
    pref_analytics_desc:
        "De analytische cookies die wij op onze site gebruiken, stellen ons in staat het aantal bezoekers aan onze site te tellen, met name om statistieken en verkeers- en gebruiksvolumes op te stellen. Deze cookies kunnen worden geplaatst door Vinfast of onze dienstverleners. Deze cookies maken gebruik van IP-adresanonimiseringstechnologie",
    pref_analytics_optout:
        "Wir werden nicht in der Lage sein, die Nutzung unserer Website zu analysieren und ihren Inhalt zu verbessern",

    pref_advert: "Adverteren",
    pref_advert_desc:
        "Deze cookies helpen om u advertenties aan te bieden die relevant voor u kunnen zijn",
    pref_advert_optout:
        "We zijn niet in staat u gepersonaliseerde advertenties aan te bieden",

    pref_social: "Sociale netwerken",
    pref_social_desc:
        "Deze cookies staan sociale interacties toe zoals het publiceren van commentaar op onze website",
    pref_social_optout:
        "We zijn niet in staat om u pagina's te laten delen op sociale netwerken",
    first_party: "Aanbieders van first party cookies",
    third_party: "Aanbieders van cookies van derden",
};

function OverrideCookieBanner() {
    //Get current language path
    var path = window.location.pathname;

    if (jQuery(".cc-window").hasClass("cc-type-info")) {
        //Override Element HTML
        if (path.includes("/fr_FR/")) {
            setValue_Info(cookieEU_FR_v1);
        } else if (path.includes("/de_DE/")) {
            setValue_Info(cookieEU_DE_v1);
        } else if (path.includes("/nl_NL/")) {
            setValue_Info(cookieEU_NL_v1);
        } else {
            setValue_Info(cookieEU_EN_v1);
        }
    } else if (jQuery(".cc-window").hasClass("cc-type-opt-in")) {
        if (path.includes("/fr_FR/")) {
            // console.log(path);
            setValue_Optin(cookieEU_FR_v2);
        } else if (path.includes("/de_DE/")) {
            // console.log(path);
            setValue_Optin(cookieEU_DE_v2);
        } else if (path.includes("/nl_NL/")) {
            // console.log(path);
            setValue_Optin(cookieEU_NL_v2);
        } else {
            // console.log(path);
            setValue_Optin(cookieEU_EN_v2);
        }
    }
}

function setValue_Info(object) {
    jQuery(".cc-message").html(object.message);
    jQuery(".cc-allow").html(object.accept);
    jQuery("#knowMore").html(object.know_more);
}
function setValue_Optin(object) {
    jQuery(".cc-message").html(object.message);
    jQuery(".cc-allow").html(object.accept);
    jQuery(".cc-dismiss").html(object.dismiss);
    jQuery("#securitiCmpCookiePrefBtn").html(object.pref_link);
    jQuery("#knowMore").html(object.know_more);
}

function changeCookieBannerLayout() {
    /* Add modal layout */
    jQuery(".cc-window").wrap("<div id='wrapper-cc'></div>");
    jQuery("#wrapper-cc").show();
    jQuery(".cc-window.cc-floating").removeClass("cc-right");
    jQuery(".cc-window.cc-floating").removeClass("cc-bottom");

    /* Add logo */
    jQuery(".cc-window").prepend(
        "<img class='logo' src='https://vinfastauto.eu/themes/custom/vinfast_v2/images/logo.png' alt='VinFast' width='65px' />"
    );
    jQuery(".cc-btn:last-child").append("<br />");
    jQuery("#securitiCmpCookiePrefBtn span:first-child").remove();

    /* Re-order button */
    jQuery(".cc-btn.cc-dismiss").insertBefore(".cc-btn.cc-allow");
    jQuery(".cc-window.cc-floating").append("<div id='prefDiv'></div>");
    jQuery(".cc-window.cc-floating").append("<div id='knowMore'></div>");
    jQuery("#securitiCmpCookiePrefBtn").appendTo("#prefDiv");

    jQuery(".cc-message > a.cc-link").appendTo("#knowMore");
    //jQuery("#knowMore").append("]");

    /* Add event click to button */
    document
        .querySelectorAll(".cc-btn")
        .forEach((item) =>
            item.addEventListener("click", () => jQuery("#wrapper-cc").hide())
        );
}

function changePreferenceCenterLayout() {
    var path = window.location.pathname;

    if (path.includes("/fr_FR/")) {
        changePreferenceCenterLayoutOptin(cookieEU_FR_v2);
    } else if (path.includes("/de_DR/")) {
        changePreferenceCenterLayoutOptin(cookieEU_DE_v2);
    } else if (path.includes("/nl_NL/")) {
        changePreferenceCenterLayoutOptin(cookieEU_NL_v2);
    } else {
        changePreferenceCenterLayoutOptin(cookieEU_EN_v2);
    }
}

function changePreferenceCenterLayoutOptin(object) {
    /* Remove un-use element */
    jQuery(".cmp-logo-wrapper").remove();
    jQuery(".cmp-modal__sub-title").remove();
    /* Remove 1st/3rd Party Section */
    //jQuery(".cmp-tabs__sub-title").remove();
    /* Remove Country Row */
    jQuery(".cmp-cookie-info").each(function () {
        if (jQuery(this).children("tbody").children("tr").children("tr").last()) {
            jQuery("td.cmp-cookie-head").each(function () {
                if (
                    jQuery(this).html() == "Country" ||
                    jQuery(this).html() == "Land" ||
                    jQuery(this).html() == "Pays"
                ) {
                    jQuery(this).parent("tr").remove();
                }
            });
        }
    });
    /* Translate texts */
    jQuery(".cmp-modal__title").html(object.pref_header);
    jQuery(".cmp-save-btn").html(object.btn_save);
    jQuery(".cmp-btn-wrapper").append(
        '<div id="knowMorePref">' + object.know_more + "</div>"
    );
    jQuery(".cmp-tabs__section")
        .children(".cmp-tabs__sub-title")
        .html(object.first_party);
    jQuery(".cmp-tab-content")
        .children(".cmp-tabs__sub-title")
        .html(object.third_party);
    jQuery("li.cmp-category").each(function () {
        if (jQuery(this).attr("id") == "Essential") {
            jQuery(this)
                .children(".cmp-prevent-default")
                .children("span:nth-child(2)")
                .html(object.pref_essential);
        } else if (jQuery(this).attr("id") == "Advertising") {
            jQuery(this)
                .children(".cmp-prevent-default")
                .children("span:nth-child(2)")
                .html(object.pref_advert);
        } else if (jQuery(this).attr("id") == "Analytics and audience metrics") {
            jQuery(this)
                .children(".cmp-prevent-default")
                .children("span:nth-child(2)")
                .html(object.pref_analytics);
        } else if (jQuery(this).attr("id") == "Performances & Functionalities") {
            jQuery(this)
                .children(".cmp-prevent-default")
                .children("span:nth-child(2)")
                .html(object.pref_performance);
        } else if (jQuery(this).attr("id") == "Social Networking") {
            jQuery(this)
                .children(".cmp-prevent-default")
                .children("span:nth-child(2)")
                .html(object.pref_social);
        }
    });
    /* Translate Elements */
    jQuery("div.cmp-tab-content").each(function () {
        if (jQuery(this).data("category") == "Essential") {
            jQuery(this)
                .children(".cmp-tabs__header")
                .children(".cmp-tabs__title")
                .html(object.pref_essential);
            jQuery(this).children(".cmp-tabs__desc").html(object.pref_essential_desc);
        } else if (jQuery(this).data("category") == "Advertising") {
            jQuery(this)
                .children(".cmp-tabs__header")
                .children(".cmp-tabs__title")
                .html(object.pref_advert);
            jQuery(this).children(".cmp-tabs__desc").html(object.pref_advert_desc);
            jQuery(this)
                .children(".cmp-tabs__opt-out")
                .html(object.pref_advert_optout);
        } else if (
            jQuery(this).data("category") == "Analytics and audience metrics"
        ) {
            jQuery(this)
                .children(".cmp-tabs__header")
                .children(".cmp-tabs__title")
                .html(object.pref_analytics);
            jQuery(this).children(".cmp-tabs__desc").html(object.pref_analytics_desc);
            jQuery(this)
                .children(".cmp-tabs__opt-out")
                .html(object.pref_analytics_optout);
        } else if (
            jQuery(this).data("category") == "Performances & Functionalities"
        ) {
            jQuery(this)
                .children(".cmp-tabs__header")
                .children(".cmp-tabs__title")
                .html(object.pref_performance);
            jQuery(this)
                .children(".cmp-tabs__desc")
                .html(object.pref_performance_desc);
            jQuery(this)
                .children(".ccmp-tabs__opt-out")
                .html(object.pref_performance_optout);
        } else if (jQuery(this).data("category") == "Social Networking") {
            jQuery(this)
                .children(".cmp-tabs__header")
                .children(".cmp-tabs__title")
                .html(object.pref_social);
            jQuery(this).children(".cmp-tabs__desc").html(object.pref_social_desc);
            jQuery(this)
                .children(".cmp-tabs__opt-out")
                .html(object.pref_social_optout);
        }
    });
    /* Add event click to button */
    document
        .querySelectorAll(".cmp-save-btn")
        .forEach((item) =>
            item.addEventListener("click", () => jQuery("#wrapper-cc").hide())
        );
}

function checkCookieExist() {
    if (
        Cookies.get("__privaci_cookie_consents") &&
        !sessionStorage._isClosedBanner
    ) {
        //if cookie is set
        jQuery("body").append("<div id='cookieNoticeWrap'></div>");
        jQuery("#cookieNoticeWrap").append("<div id='cookieNotice'></div>");

        var consentValue = jQuery.parseJSON(
            Cookies.get("__privaci_cookie_consents")
        );
        var path = window.location.pathname;
        if (Object.keys(consentValue["consents"]).length > 1) {
            if (path.includes("/fr_FR/")) {
                jQuery("#cookieNotice").append(cookieEU_FR_v2.mesg_2nd);
            } else if (path.includes("/de_DE/")) {
                jQuery("#cookieNotice").append(cookieEU_DE_v2.mesg_2nd);
            } else if (path.includes("/nl_NL/")) {
                jQuery("#cookieNotice").append(cookieEU_NL_v2.mesg_2nd);
            } else {
                jQuery("#cookieNotice").append(cookieEU_EN_v2.mesg_2nd);
            }

            jQuery("#cookieNotice").append(
                "<a class='cc-btn' id='btnCloseBanner'>OK</a>"
            );

            document.getElementById("showPrefCent").addEventListener(
                "click",
                (window.showConsentPreferencesPopup = function (e) {
                    preferenceCenterGeneration.showCookiePreference(e, null, !1, !0);
                })
            );

            // document.getElementById("enable-cookie-settings").addEventListener(
            //   "click",
            //   (window.showConsentPreferencesPopup = function (e) {
            //     preferenceCenterGeneration.showCookiePreference(e, null, !1, !0);
            //   })
            // );
        } else {
            if (path.includes("/fr_FR/")) {
                jQuery("#cookieNotice").append(cookieEU_FR_v1.mesg_2nd);
            } else if (path.includes("/de_DE/")) {
                jQuery("#cookieNotice").append(cookieEU_DE_v1.mesg_2nd);
            } else if (path.includes("/nl_NL/")) {
                jQuery("#cookieNotice").append(cookieEU_NL_v1.mesg_2nd);
            } else {
                jQuery("#cookieNotice").append(cookieEU_EN_v1.mesg_2nd);
            }

            jQuery("#cookieNotice").append(
                "<a class='cc-btn' id='btnCloseBanner'>OK</a>"
            );
        }

        document
            .getElementById("btnCloseBanner")
            .addEventListener("click", function () {
                sessionStorage.setItem("_isClosedBanner", "1");
                jQuery("#cookieNoticeWrap").hide();
            });
    }
}

function UpdateCookies() {
    setTimeout(function () {
        var uuid;
        var policy_version;
        var domain_id;
        var unixtime = Math.round(+new Date() / 1000);
        var date = new Date();
        var expiryDate = new Date(date.getFullYear(), date.getMonth() + 6, date.getDate());
        var x_token;
        var consent_time;
        var hostname = window.location.hostname;
        var essential, analytic, adverting, performance, social, unclass;

        if (hostname == "shop.vinfastauto.eu") {
            x_token = "fd8bd1d9-ea90-4a11-bf51-601935c70b0f";
            domain_id = 2;
            essential = 15
            analytic = 14
            adverting = 13
            unclass = 18
        }
        else {
            x_token = "a569bd1c-55ad-4fc9-b088-8847e295d565";
            domain_id = 3;
            essential = 21
            analytic = 20
            adverting = 19
        }

        if (Cookies.get("__privaci_cookie_consent_uuid")) {
            var c = Cookies.get("__privaci_cookie_consent_uuid")
            uuid = c.split(":")[0]
            policy_version = c.split(":")[1]
        }

        if (Cookies.get("__privaci_cookie_consents")) {
            var c = Cookies.get("__privaci_cookie_consents")
            var cookies = jQuery.parseJSON(c)
            var newContent = "";

            var __privaci_cookie_consents = newContent.concat('__privaci_cookie_consents = {\"consents\":{\"', essential, '\":1,\"', adverting, '\":0,\"', analytic, '\":1,\"', unclass, '\":0},\"location\":\"', cookies["location"], '\",\"lang\":"', cookies["lang"], '\"}');

            document.cookie = "__privaci_cookie_consents =; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
            document.cookie = __privaci_cookie_consents.concat("; expires=", expiryDate, "; path=/;")
            consent_time = "consent_time=";
            document.cookie = consent_time.concat(unixtime, "; expires=", expiryDate, "; path=/;")
        }

        var consentedItem = {
            "uuid": uuid,
            "domain_id": domain_id,
            "policy_version": policy_version,
            "consents": [
                {
                    "cookie": {
                        "property_id": essential
                    },
                    "granted": true,
                    "timestamp": unixtime
                },
                {
                    "cookie": {
                        "property_id": adverting
                    },
                    "granted": false,
                    "timestamp": unixtime
                },
                {
                    "cookie": {
                        "property_id": analytic
                    },
                    "granted": true,
                    "timestamp": unixtime
                },
                {
                    "cookie": {
                        "property_id": unclass
                    },
                    "granted": false,
                    "timestamp": unixtime
                }
            ]
        }

        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://app.eu.securiti.ai/privaci/v1/consent/cookie/singleupload', false);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.setRequestHeader('X-Auth-Token', x_token);

        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                var resp = JSON.parse(xhr.response)
                if (resp.status === 0) {
                    console.log(resp.message);
                }
            } else {
                console.log('consent upload failed', this.status, xhr.statusText);
            }
            setTimeout(function () { isConsentTaken = false }, 0)
        };
        xhr.onerror = function () {
            console.log('consent upload failed', this.status, xhr.statusText);
            setTimeout(function () { isConsentTaken = false }, 0)
        };
        xhr.send(JSON.stringify(consentedItem));

    }, 3000)
    //window.location.reload();
}

function waitForElm(selector) {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}

function changeLayoutAfter1stVisit() {
    waitForElm(".cmp-modal__header").then((elm) => {
        changePreferenceCenterLayout();
    });
}

function cookiesSetting() {
    showConsentPreferencesPopup();
    waitForElm(".cmp-modal__header").then((elm) => {
        changePreferenceCenterLayout();
    });
}

/* Main function */
jQuery(document).ready(function () {
    $('.footer_cookielink').click(function(e){
        e.preventDefault()
        cookiesSetting();
    });
    waitForElm(".cc-window").then((elm) => {
        changeCookieBannerLayout();
        OverrideCookieBanner();

        /* Add event click to button */
        // document
        //     .querySelectorAll(".cc-btn.cc-dismiss")
        //     .forEach((item) =>
        //         item.addEventListener("click", () => UpdateCookies())
        //     );

        var path = window.location.pathname;
        if (path.includes("privacy-policy")) jQuery("#wrapper-cc").hide();

        var prefButton = document.getElementById("securitiCmpCookiePrefBtn");
        if (prefButton != null)
            prefButton.addEventListener("click", function () {
                waitForElm(".cmp-modal__header").then((elm) => {
                    changePreferenceCenterLayout();
                });
            });
    });

});